var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-input-container",class:[
    `editor-input-container-${_vm.styleType}`,
    { 'editor-input-container-border': _vm.border },
  ]},[(_vm.label)?_c('div',{staticClass:"editor-input-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('el-input',_vm._b({attrs:{"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":_vm.handleInput,"focus":_vm.focus,"blur":_vm.blur}},'el-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }